<template>
  <div class="content">
    <div class="thehome">{{ $t("header.home") }} &nbsp;/</div>
    <div class="require">
      (<span style="color: #ed7e64">*</span>)&nbsp;{{
        $t("header.This_field_is_required")
      }}
    </div>
    <div class="inputcontent">
      <div class="one">
        {{ $t("header.Shanghai_ACM_SIGGRAPH_chapter_membership_table") }}
      </div>
      <div class="member_table">
        <div class="inputtype">{{ $t("header.Personal_information") }}</div>
        <div class="row">
          <div class="flex toright">
            <div class="tothetitle">
              {{ $t("header.Personal_information") }}*
            </div>
            <div class="input">
              <el-input
                v-model="state.name"
                :placeholder="$t('header.name')"
                type="text"
              ></el-input>
            </div>
          </div>
          <div class="flex">
            <!-- <div class="tothetitle">联系方式*</div>
            <div class="input">
              <el-input
                v-model="state.contact"
                placeholder="联系方式"
                type="text"
              ></el-input>
            </div> -->
          </div>
        </div>
        <div class="inputtype">{{ $t("header.Address_information") }}*</div>
        <div class="row toright">
          <div class="flex toright tobottom">
            <div class="tothetitle">{{ $t("header.nation") }}*</div>
            <div class="input">
              <el-input
                v-model="state.nation"
                :placeholder="$t('header.nation')"
                type="text"
              ></el-input>
            </div>
          </div>
          <div class="flex">
            <div class="tothetitle">{{ $t("header.province") }}*</div>
            <div class="input">
              <el-input
                v-model="state.province"
                :placeholder="$t('header.province')"
                type="text"
              ></el-input>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="flex toright tobottom">
            <div class="tothetitle">{{ $t("header.city") }}*</div>
            <div class="input">
              <el-input
                v-model="state.city"
                :placeholder="$t('header.city')"
                type="text"
              ></el-input>
            </div>
          </div>
          <div class="flex">
            <div class="tothetitle">{{ $t("header.Postal_code") }}*</div>
            <div class="input">
              <el-input
                v-model="state.postal"
                :placeholder="$t('header.Postal_code')"
                type="text"
              ></el-input>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="flex">
            <div class="tothetitle">{{ $t("header.street") }}*</div>
            <div class="input">
              <el-input
                v-model="state.street"
                :placeholder="$t('header.street')"
                type="text"
              ></el-input>
            </div>
          </div>
        </div>
        <div class="inputtype">{{ $t("header.Contact_information") }}*</div>
        <div class="row">
          <div class="flex toright tobottom">
            <div class="tothetitle">{{ $t("header.telephone") }}*</div>
            <div class="input">
              <el-input
                v-model="state.phone"
                :placeholder="$t('header.telephone')"
                type="text"
              ></el-input>
            </div>
          </div>
          <div class="flex">
            <div class="tothetitle">{{ $t("header.email") }}*</div>
            <div class="input">
              <el-input
                v-model="state.mailbox"
                :placeholder="$t('header.email')"
                type="email"
                @input="email"
                :class="state.emailerror && 'error'"
                :style="
                  state.emailerror && 'border: 2px solid #43327!important;'
                "
              ></el-input>
              <div
                v-if="state.emailerror"
                style="
                  color: #d43327;
                  margin-top: 10px;
                  font-weight: 800;
                  position: absolute;
                "
              >
                请输入正确邮箱
              </div>
            </div>
            <!-- <div class="hint">
              如果您过去是ACM的会员,或者拥有ACM账户,请输入改电子邮件地址,以使此会员资格与该记录保持一致
            </div> -->
          </div>
        </div>
        <div class="inputtype">{{ $t("header.Membership_type") }}*</div>
        <div class="row">
          <el-radio-group v-model="state.radio1" class="ml-4">
            <el-radio class="right-80" label="1" size="large">{{
              $t("header.Professional")
            }}</el-radio>
            <el-radio class="" label="2" size="large">{{
              $t("header.Student")
            }}</el-radio>
          </el-radio-group>
        </div>
        <div class="inputtype">{{ $t("header.Membership_survey") }}*</div>
        <div class="row">
          <div class="selection">{{ $t("header.Main_job_functions") }}</div>
          <div style="flex: 1">
            <el-checkbox-group v-model="state.checkList">
              <div class="check">
                <el-checkbox :label="$t('header.architect')" />
                <el-checkbox :label="$t('header.artist')" />
                <el-checkbox :label="$t('header.educator')" />
              </div>
              <div class="check">
                <el-checkbox :label="$t('header.engineer')" />
                <el-checkbox :label="$t('header.Film_Producer')" />
                <el-checkbox :label="$t('header.Game_developers')" />
              </div>
              <div class="check">
                <el-checkbox :label="$t('header.Graphic_design')" />
                <el-checkbox :label="$t('header.Manager_Executive')" />
                <el-checkbox :label="$t('header.Musician')" />
              </div>
              <div class="check">
                <el-checkbox :label="$t('header.Product_Design')" />
                <el-checkbox
                  :label="$t('header.Research_Institute/Scientist')"
                />
                <el-checkbox
                  :label="$t('header.Software_Developer/Programmer')"
                />
              </div>
              <div class="check">
                <el-checkbox :label="$t('header.Student')" />
                <el-checkbox :label="$t('header.Tech_Artist')" />
                <el-checkbox :label="$t('header.Photographer_Video_Editor')" />
              </div>
              <div class="check">
                <el-checkbox
                  :label="$t('header.Network_developers/e-commerce')"
                />
                <el-checkbox :label="$t('header.other')" />
              </div>
            </el-checkbox-group>
          </div>
        </div>
        <div class="row">
          <div class="selection">{{ $t("header.Areas_of_interest") }}</div>
          <div style="flex: 1">
            <el-checkbox-group v-model="state.checkList2">
              <div class="check">
                <el-checkbox :label="$t('header.animation')" />
                <el-checkbox :label="$t('header.artificial_intelligence')" />
                <el-checkbox :label="$t('header.Broadcast/Dynamic_Design')" />
              </div>
              <div class="check">
                <el-checkbox :label="$t('header.CAD/CAM/CAE')" />
                <el-checkbox
                  :label="$t('header.Digital_Photography/Digital_Imaging')"
                />
                <el-checkbox :label="$t('header.education')" />
              </div>
              <div class="check">
                <el-checkbox :label="$t('header.Emerging_technologies')" />
                <el-checkbox :label="$t('header.Movies/Videos')" />
                <el-checkbox
                  :label="$t('header.Art/Performance/Installation')"
                />
              </div>
              <div class="check">
                <el-checkbox :label="$t('header.Games/Game_Development')" />
                <el-checkbox
                  :label="$t('header.Illustration/Graphic_Design')"
                />
                <el-checkbox :label="$t('header.image_processing')" />
              </div>
              <div class="check">
                <el-checkbox :label="$t('header.Interactive_technology')" />
                <el-checkbox :label="$t('header.Internet/Telecom')" />
                <el-checkbox :label="$t('header.multimedia')" />
              </div>
              <div class="check">
                <el-checkbox :label="$t('header.Music/Audio')" />
                <el-checkbox :label="$t('header.Physical_calculations')" />
                <el-checkbox :label="$t('header.pipeline')" />
              </div>
              <div class="check">
                <el-checkbox
                  :label="$t('header.Programming/Software_Development')"
                />
                <el-checkbox :label="$t('header.Scientific_Visualization')" />
                <el-checkbox :label="$t('header.Special_effects/synthesis')" />
              </div>
              <div class="check">
                <el-checkbox :label="$t('header.Virtual/Augmented_Reality')" />
                <el-checkbox :label="$t('header.Web_Design')" />
                <el-checkbox :label="$t('header.other')" />
              </div>
            </el-checkbox-group>
          </div>
        </div>
        <div
          class="submit"
          @click="submit"
          :class="
            state.name &&
            state.nation &&
            state.province &&
            state.city &&
            state.postal &&
            state.street &&
            state.phone &&
            state.mailbox &&
            state.radio1 &&
            state.checkList.length &&
            state.checkList2.length &&
            'click'
          "
        >
          <div class="tj">{{ $t("header.submit") }}</div>
          <div>
            <img
              src="https://bunseninstitute.oss-cn-hangzhou.aliyuncs.com/files/images/join_icon_arrow.svg"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ElNotification } from "element-plus";
import { submit_form } from "@/api/type.js";
import { reactive, computed } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
const router = useRouter();
const { locale } = useI18n();
const state = reactive({
  name: "",
  contact: "",
  nation: "",
  province: "",
  city: "",
  postal: "",
  street: "",
  phone: "",
  mailbox: "",
  checkList: [],
  checkList2: [],
  radio1: false,
  emailerror: false,
});
// 决定提交方法是否执行及动态样式
// ref: sub = computed(() => {
//   if (
//     state.name &&
//     state.nation &&
//     state.province &&
//     state.city &&
//     state.postal &&
//     state.street &&
//     state.phone &&
//     state.mailbox &&
//     state.radio1 &&
//     state.checkList &&
//     state.checkList2
//   ) {
//     return true;
//   } else {
//     return false;
//   }
// });
// ref : sub = 1
// 提交分会会员表单的权限
const email = (e) => {
  const emailPattern = /^[\w\.-]+@[\w\.-]+\.\w+$/;
  if (emailPattern.test(e)) {
    state.emailerror = false;
  } else {
    state.emailerror = true;
  }
};
const submit = async () => {
  if (
    state.name &&
    state.nation &&
    state.province &&
    state.city &&
    state.postal &&
    state.street &&
    state.phone &&
    state.mailbox &&
    state.radio1 &&
    state.checkList &&
    state.checkList2 &&
    !state.emailerror
  ) {
    // console.log(state.radio1, 98989);
    const data = await submit_form({
      username: state.name,
      country: state.nation,
      province: state.province,
      city: state.city,
      street: state.street,
      phone: state.phone,
      postal_code: state.postal,
      email: state.mailbox,
      member_type: state.radio1,
      main_job_functions: state.checkList,
      areas_of_interest: state.checkList2,
    });
    if (data) {
      ElNotification({
        title: (locale.value == "zh" && "成功") || "success",
        message:
          (locale.value == "zh" && "分会会员表填写成功!正在为您跳转到首页") ||
          "Chapter membership form completed successfully! Going to the home page for you",
        type: "success",
      });
      setTimeout(() => {
        router.push('/')
        
      }, 1000);
    }

    console.log(data, 987);
  }
};
</script>
<style lang="scss">
.el-input__wrapper {
  height: 64px;
  box-sizing: border-box;
  padding: 20px 20px !important;
  border: 2px solid #777777 !important;
  border-radius: 8px !important;
  background-color: #d8ddf9;
}
.error {
  .el-input__wrapper {
    border: 2px solid #d43327 !important;
  }
}
.el-checkbox__inner {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid #333333;
  background: #d8ddf9;
}
@media screen and (max-width: 600px) {
  .check {
    .el-checkbox {
      width: 100%;
      .el-checkbox__label{
        font-size: 14px;
      }
     
    }
  }
}
.el-checkbox {
  width: 30.3%;
}
.el-checkbox__label {
  font-size: 16px;
  color: #333;
  font-weight: bold;
  width: 33.3%;
  text-align: left;
}
.el-checkbox__input.is-checked .el-checkbox__inner {
  border-color: #000;
  background: #4a53d7;
}
.el-checkbox__inner::after {
  display: none;
  left: 8px !important;
  top: 5px !important;
}
.el-radio-group {
  width: 100%;
  color: #000;
  background: #d8ddf9;
  .el-radio {
    color: #000;
    font-size: 26px !important;
    font-weight: 800;

    .el-radio__inner {
      width: 20px;
      height: 20px;
      border: 2px solid #000;
      background: #d9ddf9;

      &::after {
        width: 10px;
        height: 10px;
        background-color: #000;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
@import "@/sass/index.scss";
.content {
  position: relative;
  .thehome {
    z-index: 0;
    max-width: 1176px;
    margin: 0 auto;
    // height: 500px;
    position: relative;
    padding: 68px 0 0 0;
    text-align: left;
    margin-bottom: 80px;
  }
  .require {
    z-index: 0;
    max-width: 1176px;
    margin: 0 auto;
    text-align: right;
    @include fontstyle(#333, 16px, 800, auto);
    margin-bottom: 16px;
  }
  .inputcontent {
    background: #d7ddfa;
    padding: 82px 84px 0px 84px;
    z-index: 0;
    max-width: 1176px;
    margin: 0 auto;
    box-sizing: border-box;
  }
  .one {
    text-align: center;
    display: inline-block;
    @include fontstyle(#333, 40px, 800, auto);
    line-height: 47px;
    margin-bottom: 48px;
    // border-bottom: 8px solid #f4775e;
    // padding-bottom: 3px;
  }
  .member_table {
    max-width: 1176px;
    margin: 0 auto 56px;
    display: flex;
    flex-direction: column;
    .inputtype {
      @include fontstyle(#3657db, 22px, 800, auto);
      text-align: left;
      margin-bottom: 24px;
    }

    .submit {
      width: 232px;
      height: 106px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;

      :nth-child(2) {
        position: absolute;
        transition: all 0.5s;
        margin-bottom: 0px;
        left: 78px;
        opacity: 0;
        img {
          width: auto !important;
        }
      }
      &:hover {
        :nth-child(2) {
          left: 160px;
          opacity: 1;
        }
      }

      @include fontstyle(#fff, 20px, 800, auto);
      cursor: no-drop;
      line-height: 106px;
      position: relative;
      background: #ccc;
      right: -82px;
      align-self: flex-end;
      .tj {
        display: flex;
        align-items: center;
        justify-content: center;

        // &::after {
        //   content: url(https://bunseninstitute.oss-cn-hangzhou.aliyuncs.com/files/images/join_icon_arrow.svg);
        //   // display: block;
        //   margin-left: 20px;
        //   // position: absolute;
        //   // top: -9%;
        //   // right: 50%;
        //   // transform: translate(50%, 50%);
        // }
      }
    }
    .click {
      background: #3657db;
      cursor: pointer;
    }
    .row {
      display: flex;
      margin-bottom: 40px;
      align-items: center;
      .check {
        width: 100%;
        display: flex;
        margin-bottom: 25px;
        justify-content: normal;
      }
      .selection {
        @include fontstyle(#333, 16px, 800, auto);
        align-self: baseline;
        margin-top: 10px;
        margin-right: 72px;
      }
      .radiolist {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
      // width: 100%;
      // justify-content: space-between;

      .flex {
        flex: 1;
        text-align: left;
        .hint {
          text-align: left;
          color: #666;
          margin-top: 10px;
          line-height: 20px;
          margin-bottom: 20px;
        }
      }
      .toright {
        margin-right: 40px;
      }
      .right-80 {
        margin-right: 100px;
      }
    }

    .tothetitle {
      font-size: 18px;
      font-weight: 800;
      text-align: left;
      margin-bottom: 12px;
    }
  }
}
@media screen and (max-width: 1200px) {
  .content {
    padding: 30px;
  }
}
@media screen and (max-width: 1000px) {
  .row {
    display: flex;
    flex-direction: column;
    .flex {
      width: 100%;
    }
    .toright {
      margin-right: 0px !important;
    }
    .tobottom {
      margin-bottom: 40px;
    }
  }
}
@media screen and (max-width: 800px) {

  .inputcontent {
    padding: 82px 30px 0px 30px !important;
  }
  .submit {
    right: -30px !important;
  }
  .row {
    .selection {
      margin-bottom: 30px;
    }
    .el-checkbox-group {
      .check {
        flex-wrap: wrap;
        margin-bottom: 0px !important;
      }
    }
  }
}
</style>